/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserApi } from '../../sdk/services';
import { User } from '../../lib/wwg.classes';
import { findIndex as _find } from 'lodash';
import { NotificationService } from '../../services/notification.service';

@Component({
  selector: 'app-add-member-dialog',
  templateUrl: './add-member-dialog.component.html',
  styleUrls: ['./add-member-dialog.component.scss']
})
export class AddMemberDialogComponent implements OnInit {
  users: Array<User> = [];
  items = new Array<User>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AddMemberDialogComponent>,
    private notificationService: NotificationService,
    private userApi: UserApi) { }

  ngOnInit() {
    // Fetch All Members (Filter to make sure data exists, Removes forced added users)
    this.userApi.list().toPromise().then((response: any) => {
      this.items = response;

      // Push Selected
      this.data.members.forEach((item) => {
        // Find Matching ID
        const id = _find(this.items, function (o) { return o._id === item._id; });
        this.users.push(this.items[id]);
      });
    }).catch(this.notificationService.errorHandler);
  };

  addMember() {
    this.dialogRef.close(this.users);
  }
}
